<template>
	<el-row>
		<el-col :span="8">
			<div id='containerPie1'></div>
		</el-col>
		<el-col :span="8">
			<div id='containerPie2'></div>
		</el-col>
		<el-col :span="8">
			<div id='containerPie3'></div>
		</el-col>
	</el-row>
</template>

<script>
	import Api from '../../api'
	import { mapState, mapMutations, mapActions } from 'vuex'
	import echarts from 'echarts';
	export default {
		data() {
			return {
				myChart:null
			}
		},
		computed: {
			...Vuex.mapState('supervisor', ['breadcrumbList','slider','GetReportListArr']),
			...Vuex.mapState('visualization', ['summary','trigger','setDateArr','getCountParameter']),
			...Vuex.mapState('breadcrumb', ['visPieColorList']),
			triggers() {
				return this.trigger.numberPie;
			}
		},
		watch: {
			triggers(old) {
				if(old) {
					this.initPie();
				}
			}
		},
		updated() {
			if(this.trigger.numberPie) {
				this.initPie();
			}
		},
		mounted() {
			let _this = this;

			this.erd.listenTo(document.getElementsByClassName("el-main"), function (element) {
			    _this.initPie();
		    })
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType','clearRow']),
			...Vuex.mapMutations('supervisor',['currentChangesSecond','setBreadcrumbList']),
			...Vuex.mapMutations('visualization',['setvisBreadcrumbList']),
			// ...Vuex.mapActions('supervisor', ['']),
			initPie(){
				if (this.summary.ModalityTypes||this.summary.ScanTypes||this.summary.BodyParts) {
					this.trigger.numberPie = false;
					this.getEchartsPie('containerPie1', this.summary.ModalityTypes,'设备类型','https://qc.rimagdata.com/file/939374df-4d45-4816-8c9f-2eb8252cc7d5.png');
					this.getEchartsPie('containerPie2', this.summary.ScanTypes,'扫描方式','https://qc.rimagdata.com/file/a830d428-db19-4a92-81f7-e5a4ffb41083.png');
					this.getEchartsPie('containerPie3', this.summary.BodyParts,'检查部位','https://qc.rimagdata.com/file/3e67eae6-4f47-4d3f-9de7-ab3d77ad9d18.png');
				}
			},
			getEchartsPie(id, data,text,image) {
				let dom = document.getElementById(id);
				if (dom) {
					this.myChart = echarts.init(dom);
				}
				let app = {};
				let option = null;
				let datas = [];
				let color = [];
				if(id == 'containerPie1') {
					color = this.visPieColorList.color1;
					data.map(res => {
						datas.push({
							name: res.ModalityType,
							value: res.Count
						})
					})
				}
				if(id == 'containerPie2') {
					color = this.visPieColorList.color2;
					data.map(res => {
						datas.push({
							name: res.ScanType,
							value: res.Count
						})
					})
				}
				if(id == 'containerPie3') {
					color = this.visPieColorList.color3;
					data.map(res => {
						datas.push({
							name: res.BodyPart,
							value: res.Count
						})
					})
				}
				option = {
					color: color,
					title:{
						text:text,
						left:"center",
						top:"33%",
						textStyle:{
							color:"#ffffff",
							fontSize:this.fontSize(0.11),
							align:"center"
						}
					},
					graphic: { // 这个属性可以在饼图内部填充图片,文字等
						elements: [{
							type: 'image',//需要填充图片,配置image,如果不需要图片可以配置其他的, 
							style: {
								image:image, //这里添加图片地址
								width: this.fontSize(0.28),
								height:  this.fontSize(0.28)
							},
							left: 'center',
							top: '20%' //配置图片居中
						}]
					},
					legend: {
						icon: 'circle',
						orient: 'vertical',
						height: this.fontSize(0.8),
						// top:135,
						bottom:0,
						itemGap:this.fontSize(0.10),
						itemWidth: this.fontSize(0.07),
						itemHeight: this.fontSize(0.07),
						textStyle: {
							color:'#ffffff',
							rich: {
								a: {
									width: this.fontSize(0.45),
									fontSize: this.fontSize(0.11),
								},
								
							}
						},
						data: datas,
						formatter: function(name) {
							let target;
							for(let i = 0, l = datas.length; i < l; i++) {
								if(datas[i].name == name) {
									target = datas[i].value;
								}
							}
							let arr = [
								'{a|' + name + ': ' + target + '}',
							]
							return arr.join('\n')
						}
					},
					tooltip: {
						trigger: 'item',
						confine:true
					},
					series: [{
						name: '质控数',
						type: 'pie',
						center: ['50%', '31%'],
						radius: ['50%', '57%'],
						minAngle: 15,//最小角度
						startAngle:180, //起始角度
						hoverOffset: 2,
						label: {
							show:false,
							color: '#fff',
							formatter: '{b|{b}}',
							alignTo: 'labelLine',
							rich: {
								b: {
									align: 'left',
									color: '#fff'
								}
							},
							 normal: {
							   show : false
							}
						},
						labelLine: {
							lineStyle: {
								color: '#fff'
							},
							length2:3
						},
						data: datas
					}]
				};
				if(option && typeof option === "object") {
					this.myChart.setOption(option, true);
					this.myChart.off('click'); //清除联系点击
					this.myChart.on('click', (params) => {
						this.setTootipType(false);
						this.clearRow();
						this.currentChangesSecond(1);
						this.setBreadcrumbList();
						this.setvisBreadcrumbList();
						this.breadcrumbList.push(this.setDateArr.data[0] + '-' + this.setDateArr.data[1]);
						if(id == 'containerPie1') {
							this.GetReportListArr.type = '设备类型';
						} else if(id == 'containerPie2') {
							this.GetReportListArr.type = '扫描方式';
						} else {
							this.GetReportListArr.type = '检查部位';
						}
						this.breadcrumbList.push(params.name);
						this.GetReportListArr.name = params.name;
						this.breadcrumbList.push("pie");
						this.GetReportListArr.status = 'region';
						this.GetReportListArr.unqualified = 'false';
						this.GetReportListArr.tabType = '2';
						this.GetReportListArr.regionId = this.getCountParameter.regionId;
						//报告列表时间赋值
						this.$store.commit('supervisor/setSetDate', this.setDateArr);
						this.$store.commit('supervisor/setHospitalregionId', this.getCountParameter.regionId);
						this.$router.push("/home/supervisor/qualifiedTable");
					});
				}
				this.myChart.resize(); //区域更新
				window.addEventListener("resize", () => {
					this.myChart.resize();
				});
			}
		}
	}
</script>

<style>

</style>